(ns teamoesterreich.user-mode.location.location-form
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    ;;(h/event-value e)

    [reagent-material-ui.icons.close :refer [close]]
    [reagent-material-ui.icons.delete-outline :refer [delete-outline]]
    [reagent-material-ui.icons.home :refer [home]]


    [reagent-material-ui.icons.home :refer [home]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]

    [reagent-material-ui.icons.notifications :refer [notifications]]
    [reagent-material-ui.icons.people :refer [people]]
    [reagent-material-ui.icons.photo :refer [photo]]
    [reagent-material-ui.icons.save :refer [save]]
    [reagent.core :as r]
    [teamoesterreich.config :as config]
    [teamoesterreich.firebase.storage-provider :as storage-provider]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.navigation.bottom-bar :as bottom-bar]
    [teamoesterreich.user-mode.ui-helper.are-you-sure-modal :as ays-modal]
    [teamoesterreich.util.helper :as h]
    [teamoesterreich.util.log :as log]))

(defonce date-picker-state (r/atom nil))

(defn save-location [locationId location-obj]
  (a/set-location locationId location-obj))

(defn drop-location [locationId]
  (a/drop-location locationId))



(defn upload-button [!locationId !location]
  (let [!state (r/atom {:progress nil})
        !userId (r/cursor store/app-state [:firebase-uid])
        on-done-fn (fn [new-path]
                     ;(log/out "location image uploaded to:" new-path)
                     (save-location @!locationId {:location-picture-path new-path})
                     )]
    ;(log/out "upload-button " !locationId !location !userId)
    [mui/button {
                 :variant   "outlined"
                 ;:class "bottom-button"
                 :startIcon (r/as-element [photo])
                 :component "label"
                 :style     {:width "200px" :margin "0 0 0 10px"}
                 }
     "Neues Foto " (when (:progress @!state) (str " ... " (:progress @!state) "%"))
     [:input {:accept   "image/" :id "photoUpload"
              :type     "file"
              :hidden   true
              :onChange (fn [e]
                          ;(log/out "################################################  upload fired..." "files" (.item e.target.files 0))
                          (storage-provider/upload-location-image (.item e.target.files 0) @!userId @!locationId
                                                                  (fn [path]
                                                                    (on-done-fn path)
                                                                    (swap! !state assoc :progress nil)
                                                                    )
                                                                  (fn [p] (swap! !state assoc :progress p)))
                          )
              }]]

    ))


(defn warning-select [title value changed? change-fn]
  ;;(log/out "warning-switch " title value changed? change-fn)
  [mui/grid
   {:container false :item true
    :md        12                                           ;medium: 960px
    :xs        12                                           ;extra-small: 0px
    } [mui/form-label title
       [mui/select
        {:style     {:backgroundColor (if changed? "#ffd6d2" "#ffffff")}
         :fullWidth true
         :value     (or value "-1")
        :onChange (fn [e] (log/out title (h/event-value e)) (change-fn e))
         :label     title}
        [mui/menu-item {:value "-1"} "Alle"]
        [mui/menu-item {:value "1"} "Ab Stufe 1 `Information`"]
        [mui/menu-item {:value "2"} "Ab Stufe 2 `Vorsicht`"]
        [mui/menu-item {:value "3"} "Ab Stufe 3 `Achtung`"]
        [mui/menu-item {:value "5"} "Ab Stufe 4 `Gefahr`"]
        ]]
   [:br] [:br]
   ])

(defn f-changed [key-in form-values ori-values]
  (and (not (nil? (get-in form-values key-in))) (not= (get-in form-values key-in) (get-in ori-values key-in))))

(defn f-val [key-in form-values ori-values]
  (if (not (nil? (get-in form-values key-in))) (get-in form-values key-in) (get-in ori-values key-in)))



(defn get-it []
  (log/out "init location form !")
  (let [!st (r/atom {:location-form {}})]
    (fn []
      (let [!actual-location (r/cursor store/app-state [:state :selected-location])
            !location (r/cursor store/app-state [:locations @!actual-location])
            lat (and (get-in @!location [:coordinates]) (.-_lat ^js (get-in @!location [:coordinates])))
            lng (and (get-in @!location [:coordinates]) (.-_long ^js (get-in @!location [:coordinates])))
            !location-form (r/cursor !st [:location-form])
            !lose-data-modal (r/cursor !st [:location-form :show-lose-data-form-modal])
            !show-delete-modal (r/cursor !st [:location-form :show-delete-modal])

            f-name (f-val [:name] @!location-form @!location)
            f-name-ch (f-changed [:name] @!location-form @!location)


            f-prevent (f-val [:preparation-enabled] @!location-form @!location)
            f-prevent-ch (f-changed [:preparation-enabled] @!location-form @!location)


            f-type (f-val [:type] @!location-form @!location)
            f-type-ch (f-changed [:type] @!location-form @!location)

            f-peopleCount (f-val [:people-count] @!location-form @!location)
            f-peopleCount-ch (f-changed [:people-count] @!location-form @!location)

            f-disabilities (f-val [:disabilities] @!location-form @!location)
            f-disabilities-ch (f-changed [:disabilities] @!location-form @!location)

            f-hasBabies (f-val [:has-babies] @!location-form @!location)
            f-hasBabies-ch (f-changed [:has-babies] @!location-form @!location)

            f-kidsCount (f-val [:kids-count] @!location-form @!location)
            f-kidsCount-ch (f-changed [:kids-count] @!location-form @!location)

            f-petCount (f-val [:pet-count] @!location-form @!location)
            f-petCount-ch (f-changed [:pet-count] @!location-form @!location)



            f-zamg1 (f-val [:warning-types.zamg_1] @!location-form @!location)
            f-zamg1-ch (f-changed [:warning-types.zamg_1] @!location-form @!location)
            f-zamg2 (f-val [:warning-types.zamg_2] @!location-form @!location)
            f-zamg2-ch (f-changed [:warning-types.zamg_2] @!location-form @!location)
            f-zamg3 (f-val [:warning-types.zamg_3] @!location-form @!location)
            f-zamg3-ch (f-changed [:warning-types.zamg_3] @!location-form @!location)
            f-zamg4 (f-val [:warning-types.zamg_4] @!location-form @!location)
            f-zamg4-ch (f-changed [:warning-types.zamg_4] @!location-form @!location)
            f-zamg5 (f-val [:warning-types.zamg_5] @!location-form @!location)
            f-zamg5-ch (f-changed [:warning-types.zamg_5] @!location-form @!location)
            f-zamg6 (f-val [:warning-types.zamg_6] @!location-form @!location)
            f-zamg6-ch (f-changed [:warning-types.zamg_6] @!location-form @!location)
            f-zamg7 (f-val [:warning-types.zamg_7] @!location-form @!location)
            f-zamg7-ch (f-changed [:warning-types.zamg_7] @!location-form @!location)


            f-DWD_WIND (f-val [:warning-types.DWD_WIND] @!location-form @!location)
            f-DWD_WIND-ch (f-changed [:warning-types.DWD_WIND] @!location-form @!location)
            f-DWD_RAIN (f-val [:warning-types.DWD_RAIN] @!location-form @!location)
            f-DWD_RAIN-ch (f-changed [:warning-types.DWD_RAIN] @!location-form @!location)
            f-DWD_SNOWFALL (f-val [:warning-types.DWD_SNOWFALL] @!location-form @!location)
            f-DWD_SNOWFALL-ch (f-changed [:warning-types.DWD_SNOWFALL] @!location-form @!location)
            f-DWD_GLAZE (f-val [:warning-types.DWD_GLAZE] @!location-form @!location)
            f-DWD_GLAZE-ch (f-changed [:warning-types.DWD_GLAZE] @!location-form @!location)
            f-DWD_THUNDERSTORM (f-val [:warning-types.DWD_THUNDERSTORM] @!location-form @!location)
            f-DWD_THUNDERSTORM-ch (f-changed [:warning-types.DWD_THUNDERSTORM] @!location-form @!location)
            f-DWD_HEAT (f-val [:warning-types.DWD_HEAT] @!location-form @!location)
            f-DWD_HEAT-ch (f-changed [:warning-types.DWD_HEAT] @!location-form @!location)
            f-DWD_FROST (f-val [:warning-types.DWD_FROST] @!location-form @!location)
            f-DWD_FROST-ch (f-changed [:warning-types.DWD_FROST] @!location-form @!location)
            f-DWD_TORNADO (f-val [:warning-types.DWD_TORNADO] @!location-form @!location)
            f-DWD_TORNADO-ch (f-changed [:warning-types.DWD_TORNADO] @!location-form @!location)
            f-DWD_HAIL (f-val [:warning-types.DWD_HAIL] @!location-form @!location)
            f-DWD_HAIL-ch (f-changed [:warning-types.DWD_HAIL] @!location-form @!location)
            f-DWD_SNOWDRIFT (f-val [:warning-types.DWD_SNOWDRIFT] @!location-form @!location)
            f-DWD_SNOWDRIFT-ch (f-changed [:warning-types.DWD_SNOWDRIFT] @!location-form @!location)
            f-DWD_FOG (f-val [:warning-types.DWD_FOG] @!location-form @!location)
            f-DWD_FOG-ch (f-changed [:warning-types.DWD_FOG] @!location-form @!location)
            f-DWD_THAW (f-val [:warning-types.DWD_THAW] @!location-form @!location)
            f-DWD_THAW-ch (f-changed [:warning-types.DWD_THAW] @!location-form @!location)
            f-DWD_UV (f-val [:warning-types.DWD_UV] @!location-form @!location)
            f-DWD_UV-ch (f-changed [:warning-types.DWD_UV] @!location-form @!location)
            f-oerk (f-val [:warning-types.oerk] @!location-form @!location)
            f-oerk-ch (f-changed [:warning-types.oerk] @!location-form @!location)


            do-save? (or
                       f-name-ch
                       f-prevent-ch
                       f-type-ch
                       f-peopleCount-ch
                       f-disabilities-ch
                       f-hasBabies-ch
                       f-kidsCount-ch
                       f-petCount-ch
                       f-zamg1-ch
                       f-zamg2-ch
                       f-zamg3-ch
                       f-zamg4-ch
                       f-zamg5-ch
                       f-zamg6-ch
                       f-zamg7-ch

                       f-DWD_WIND-ch
                       f-DWD_RAIN-ch
                       f-DWD_SNOWFALL-ch
                       f-DWD_GLAZE-ch
                       f-DWD_THUNDERSTORM-ch
                       f-DWD_HEAT-ch
                       f-DWD_FROST-ch
                       f-DWD_TORNADO-ch
                       f-DWD_HAIL-ch
                       f-DWD_SNOWFALL-ch
                       f-DWD_FOG-ch
                       f-DWD_THAW-ch
                       f-DWD_UV-ch
                       f-oerk-ch
                       )

            makeMainLocation-fn #(a/set-user-fav-location @!actual-location @!location)

            delete-fn #(swap! !location-form assoc :show-delete-modal true)

            save-fn (fn []
                      ;(log/out "save form" @!actual-location @!location-form)
                      (save-location @!actual-location @!location-form)
                      ;(.scrollTo js/window 0 0)
                      (swap! !st assoc :profile-page nil :location-form {}))

            drop-location-fn (fn []
                               (drop-location @!actual-location)
                               (a/set-page :landing nil))

            change-fn (fn [key] (fn [e]
                                  (log/out "Change " key "-> " (h/event-value e))
                                  (swap! !location-form assoc-in key (h/event-value e))))

            change-switch-fn (fn [key] (fn [e]
                                         (log/out "Change " key "-> " (.. e -target -checked))
                                         (swap! !location-form assoc-in key (.. e -target -checked))))

            real-back-fn (fn []
                           (.scrollTo js/window 0 0)
                           (a/set-page-back))

            back-fn (fn [_]
                      (log/out "back-fn called")
                      (if do-save?
                        (swap! !location-form assoc :show-lose-data-form-modal true)
                        (real-back-fn)))

            ]
        (log/out "redraw form" @!actual-location @!location @!location-form)
        (bottom-bar/set-actions back-fn (when do-save? save-fn))

        [mui/grid
         {:container  true
          :style      {:marginTop "10px"}
          :direction  "column"
          :justify    "center"
          :alignItems "center"
          :spacing    4

          }

         [mui/grid
          {:container false :item true
           :md        6                                     ;medium: 960px
           :xs        12                                    ;extra-small: 0px
           }
          [mui/card {:class ""
                     :style {:textAlign "left" :padding "25px"}}
           [ays-modal/are-you-sure-modal !lose-data-modal "Dieses Formular hat nicht gespeicherte Daten. Willst du es wirklich schließen?" "Eingabe verwerfen"
            real-back-fn]
           [ays-modal/are-you-sure-modal !show-delete-modal "Willst du wirklich diesen Standort löschen?" "Löschen"
            drop-location-fn]
           [mui/card-media
            {:component "img"
             :image     (or (when-not (= "" (:location-picture-path-fst @!location)) (:location-picture-path-fst @!location))
                            (and lat lng
                                 (str "https://maps.googleapis.com/maps/api/staticmap?"
                                      "center=" lat "," lng "&zoom=12&size=1000x200&"
                                      "markers=color:red|" lat "," lng
                                      "&key= " config/GOOGLE_MAPS_API " &"
                                      ))
                            "/custom/img/home.png")
             :height    "200"
             :title     (str (get-in @!location [:name]))
             :alt       (str (get-in @!location [:name]))
             }]
           [mui/card-actions
            [mui/button {:variant   "outlined" :startIcon (r/as-element [home])
                         :component "span" :onClick makeMainLocation-fn}
             "Als Wohnadresse machen"]



            (if (and (:location-picture-path-fst @!location) (not= "" (:location-picture-path-fst @!location)))
              [mui/button {:variant   "outlined"
                           :startIcon (r/as-element [close])
                           :component "label"
                           :style     {:width "200px" :margin "0 0 0 10px"}
                           :onClick   (fn []
                                        (swap! !location dissoc :location-picture-path-fst)
                                        (save-location @!actual-location {:location-picture-path nil}))
                           }
               "Foto entfernen"]
              [upload-button !actual-location !location])

            ]

           [mui/card-content
            [mui/grid
             {:container  true
              :direction  "column"
              :justify    "space-between"
              :alignItems "flex-start"
              :spacing    1
              }
             [mui/grid
              {:container false :item true
               :xs        12                                ;extra-small: 0px
               }
              [:h1 [home] " Standorteinstellungen"]
              ]

             [mui/grid
              {:container  true
               :direction  "row"
               :justify    "flex-start"
               :alignItems "flex-start"
               :spacing    1
               :style      #js {:margin "0"}
               }
              [mui/grid
               {:container false :item true
                :md        12                               ;medium: 960px
                :xs        12                               ;extra-small: 0px
                :style     #js {:padding "15px"}
                }
               [mui/text-field {
                                :style        #js {:backgroundColor (if f-name-ch "#ffd6d2" "#ffffff")}
                                :fullWidth    true
                                :defaultValue f-name
                                :onChange     (change-fn [:name])
                                :label        "Standort Name"}]

               ]


              ;; address
              [mui/grid
               {:container false :item true
                :md        12                               ;medium: 960px
                :xs        12                               ;extra-small: 0px
                :style     #js {:padding "15px"}
                }
               [mui/text-field {
                                :fullWidth    true
                                :title        "Standort ist nicht neu positionierbar. Nutze dafür einen neuen Standort."
                                :defaultValue (get-in @!location [:address])
                                :disabled     true
                                :label        "Adresse"}]

               ]

              ;; prevent switch
              [mui/grid
               {:container false :item true
                :md        12                               ;medium: 960px
                :xs        12                               ;extra-small: 0px
                :style     #js {:padding "15px"}
                }
               [mui/grid
                {:container true
                 :style     {:backgroundColor (if f-prevent-ch "#ffd6d2" "#ffffff")}
                 }
                [mui/grid {:container false :item true :xs 9 :style #js {}}
                 "Vorbereitung"]

                [mui/grid {:container false :item true :xs 3 :style #js {}}
                 [mui/switch {
                              :checked  (if (nil? f-prevent) false f-prevent)
                              :onChange (change-switch-fn [:preparation-enabled])
                              :name     "prevent"
                              :color    "primary"}]]]
               ]


              ;; house/flat selector
              [mui/grid
               {:container false
                :item      true
                :md        7                                ;medium: 960px
                :xs        7                                ;extra-small: 0px
                :style     {:padding "15px"}
                }
               [mui/form-label "Haus / Wohnung"
                [mui/select
                 {
                  ;:InputProps {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [wc]])}
                  :style     {:backgroundColor (if f-type-ch "#ffd6d2" "#ffffff")}
                  :fullWidth true
                  :value     (or f-type "flat")
                  :onChange  (change-fn [:type])
                  }
                 [mui/menu-item {:value "house"} "Haus"]
                 [mui/menu-item {:value "flat"} "Wohnung"]
                 ]]

               ]




              [mui/grid
               {:container false :item true
                :xs        12                               ;extra-small: 0px
                }
               [:h1 [people] " Bewohner"]
               ]

              ;; people
              [mui/grid
               {:container false :item true
                :md        12                               ;medium: 960px
                :xs        12                               ;extra-small: 0px
                :style     #js {:padding "15px"}
                }
               [mui/text-field {
                                :fullWidth    true
                                :style        {:backgroundColor (if f-peopleCount-ch "#ffd6d2" "#ffffff")}
                                :defaultValue f-peopleCount
                                :onChange     (change-fn [:people-count])
                                :label        "Bewohneranzahl"
                                :type         "number"
                                :helperText   "Anzahl Personen inklusive Kinder und Personen mit Behinderung"
                                }]

               ]

              ;; disabled switch
              [mui/grid
               {:container false :item true
                :md        12                               ;medium: 960px
                :xs        12                               ;extra-small: 0px
                :style     #js {:padding "15px"}
                }
               [mui/grid
                {:container true
                 :style     {:backgroundColor (if f-disabilities-ch "#ffd6d2" "#ffffff")}
                 }
                [mui/grid {:container false :item true :xs 9 :style {}}
                 "Bewohner mit Behinderung"]

                [mui/grid {:container false :item true :xs 3 :style {}}
                 [mui/switch {
                              :checked  (if (nil? f-disabilities) false f-disabilities)
                              :onChange (change-switch-fn [:disabilities])
                              :name     "prevent"
                              :color    "primary"}]]]
               ]
              ;; children switch
              [mui/grid
               {:container false :item true
                :md        6                                ;medium: 960px
                :xs        12                               ;extra-small: 0px
                :style     #js {:padding "15px"}
                }

               [mui/text-field {
                                :fullWidth    true
                                :style        {:backgroundColor (if f-kidsCount-ch "#ffd6d2" "#ffffff")}
                                :defaultValue f-kidsCount
                                :onChange     (change-fn [:kids-count])
                                :label        "Anzahl Kinder"
                                :type         "number"
                                }]

               ]
              ;; pets switch
              [mui/grid
               {:container false :item true
                :md        6                                ;medium: 960px
                :xs        12                               ;extra-small: 0px
                :style     #js {:padding "15px"}
                }
               [mui/text-field {
                                :fullWidth    true
                                :style        {:backgroundColor (if f-petCount-ch "#ffd6d2" "#ffffff")}
                                :defaultValue f-petCount
                                :onChange     (change-fn [:pet-count])
                                :label        "Anzahl Haustiere"
                                :type         "number"
                                }]
               ]



              [mui/grid
               {:container false :item true
                :xs        12                               ;extra-small: 0px
                }
               [:h1 [notifications] " Benachrichtigungen"]
               ]

              ;;               (warning-select "Starker Wind " f-zamg1 f-zamg1-ch (change-fn [:warning-types.zamg_1]))
              ;;               (warning-select "Starker Regenfall " f-zamg2 f-zamg2-ch (change-fn [:warning-types.zamg_2]))
              ;;               (warning-select "Schneefall " f-zamg3 f-zamg3-ch (change-fn [:warning-types.zamg_3]))
              ;;               (warning-select "Glatteis " f-zamg4 f-zamg4-ch (change-fn [:warning-types.zamg_4]))
              ;;               (warning-select "Gewitter " f-zamg5 f-zamg5-ch (change-fn [:warning-types.zamg_5]))
              ;;               (warning-select "Hitzebelastung " f-zamg6 f-zamg6-ch (change-fn [:warning-types.zamg_6]))
              ;;               (warning-select "Kältestress " f-zamg7 f-zamg7-ch (change-fn [:warning-types.zamg_7]))
              ;;
              (warning-select "Windböen " f-DWD_WIND f-DWD_WIND-ch (change-fn [:warning-types.DWD_WIND]))
              (warning-select "Starkregen " f-DWD_RAIN f-DWD_RAIN-ch (change-fn [:warning-types.DWD_RAIN]))
              (warning-select "Schneefall " f-DWD_SNOWFALL f-DWD_SNOWFALL-ch (change-fn [:warning-types.DWD_SNOWFALL]))
              (warning-select "Glatteis " f-DWD_GLAZE f-DWD_GLAZE-ch (change-fn [:warning-types.DWD_GLAZE]))
              (warning-select "Gewitter " f-DWD_THUNDERSTORM f-DWD_THUNDERSTORM-ch (change-fn [:warning-types.DWD_THUNDERSTORM]))
              (warning-select "Hitze " f-DWD_HEAT f-DWD_HEAT-ch (change-fn [:warning-types.DWD_HEAT]))
              (warning-select "Frost " f-DWD_FROST f-DWD_FROST-ch (change-fn [:warning-types.DWD_FROST]))
              (warning-select "Orkanböen " f-DWD_TORNADO f-DWD_TORNADO-ch (change-fn [:warning-types.DWD_TORNADO]))
              (warning-select "Hagel " f-DWD_HAIL f-DWD_HAIL-ch (change-fn [:warning-types.DWD_HAIL]))
              (warning-select "Schneeverwehungen " f-DWD_SNOWDRIFT f-DWD_SNOWDRIFT-ch (change-fn [:warning-types.DWD_SNOWDRIFT]))
              (warning-select "Nebel " f-DWD_FOG f-DWD_FOG-ch (change-fn [:warning-types.DWD_FOG]))
              (warning-select "Tauwetter " f-DWD_THAW f-DWD_THAW-ch (change-fn [:warning-types.DWD_THAW]))
              (warning-select "UV-Strahlung " f-DWD_UV f-DWD_UV-ch (change-fn [:warning-types.DWD_UV]))
              (warning-select "Sonstige " f-oerk f-oerk-ch (change-fn [:warning-types.oerk]))





              ;end form
              [mui/grid
               {:container false
                :item      true
                :xs        12                               ;extra-small: 0px
                :style     {:padding "15px"}
                } ""]

              [mui/grid
               {:container false :item true
                :lg        4                                ;medium: 960px
                :xs        5                                ;extra-small: 0px
                :style     #js {:padding "15px"}
                }
               [mui/button
                {:variant   "contained"
                 :class     "bottom-button"
                 :style     #js {:margin "10px 0 10px 10px"}
                 :onClick   back-fn
                 :startIcon (r/as-element [keyboard-arrow-left])
                 }
                "Zurück"]

               ]
              [mui/grid
               {:container false :item true
                :lg        4                                ;medium: 960px
                :xs        5                                ;extra-small: 0px
                :style     #js {:padding "15px"}
                }
               [mui/button
                {:variant   "contained"
                 :color     "primary"
                 :class     "bottom-button"
                 :disabled  (not do-save?)

                 :startIcon (r/as-element [save])

                 :style     #js {:margin "10px 0 10px 10px"}
                 :onClick   save-fn
                 }
                "Speichern"]

               ]
              [mui/grid
               {:container false :item true
                :lg        4                                ;medium: 960px
                :xs        5                                ;extra-small: 0px
                :style     #js {:padding "15px"}
                }
               [mui/button
                {:variant   "contained"
                 :color     "secondary"
                 :class     "bottom-button"
                 :disabled  do-save?

                 :startIcon (r/as-element [delete-outline])

                 :style     #js {:margin "10px 0 10px 10px"}
                 :onClick   delete-fn
                 }
                "Löschen"]

               ]

              ]

             ]

            ]

           ]]]
        ))))








